import React, { useState, useRef, useEffect } from "react";
import "./HourlyStandardQuoteForm.css";
import Loader from "../../../../Template/Loader/Loader";
import CommonMessageModal from "../../../CommonMessageModal/CommonMessageModal";
import { createHourlyOrEditingQuote } from "../../../../utils/APIs/bookingApis";
import { useNavigate } from "react-router-dom";
import NavigationButtons from "../../../../Template/NavigationButtons/NavigationButtons";

const metroCities = [
  "Ahmedabad", "Amritsar", "Bengaluru", "Bhopal", "Bhubaneswar", "Chandigarh",
  "Chennai", "Coimbatore", "Dehradun", "Delhi", "Faridabad", "Ghaziabad",
  "Gurugram", "Guwahati", "Hyderabad", "Indore", "Jaipur", "Jalandhar",
  "Kanpur", "Kochi", "Kolkata", "Lucknow", "Ludhiana", "Madurai", "Meerut",
  "Mumbai", "Mysuru", "Nagpur", "Nashik", "New Delhi", "Noida", "Patna",
  "Pune", "Raipur", "Rajkot", "Ranchi", "Surat", "Thane", "Thiruvananthapuram",
  "Vadodara", "Varanasi", "Vijayawada", "Visakhapatnam", "Other"
];

const HourlyStandardQuoteForm = () => {
  const navigate = useNavigate();

  const services = [
    "Wedding Shoot",
    "Maternity & Baby Shoot",
    "Event Shoot",
    "Fashion Shoot",
    "Product Shoot",
    "Food Shoot",
    "Automobile Shoot",
    "Corporate Shoot",
    "Sports Shoot"
  ];

  const requirementsList = [
    "Photography",
    "Videography",
    "Lightening setup",
    "Editing"
  ];

  const [formData, setFormData] = useState({
    clientName: "",
    eventType: "", // Category
    startDate: "", // Date
    location: "",  // City
    photographyRequirements: "", // Requirement
    phoneNumber: "",
    email: "",
  });

  const [loading, setLoading] = useState(false);
  const [showMessage, setShowMessage] = useState(false);
  const [message, setMessage] = useState("");
  const [isSuccess, setIsSuccess] = useState(false);
  const [showCategoryDropdown, setShowCategoryDropdown] = useState(false);
  const categoryDropdownRef = useRef(null);
  
  // Dropdown States for City
  const [showCityDropdown, setShowCityDropdown] = useState(false);
  const [citySearchTerm, setCitySearchTerm] = useState("");
  const [isOtherCity, setIsOtherCity] = useState(false);
  const cityDropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        categoryDropdownRef.current &&
        !categoryDropdownRef.current.contains(event.target)
      ) {
        setShowCategoryDropdown(false);
      }
      if (cityDropdownRef.current && !cityDropdownRef.current.contains(event.target)) {
        setShowCityDropdown(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const filteredCities = metroCities
    .filter((city) => city.toLowerCase().includes(citySearchTerm.toLowerCase()))
    .sort((a, b) => {
      if (a === "Other") return 1;
      if (b === "Other") return -1;
      return a.localeCompare(b);
    });

  const handleModalClose = () => {
    setShowMessage(false);
    if (isSuccess) {
      navigate("/myProfile", {
        state: { openTab: "quotes" },
      });
    }
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    if (type === "checkbox") {
      setFormData((prev) => {
        let newArr = [...prev[name]];
        if (checked) {
          newArr.push(value);
        } else {
          newArr = newArr.filter(item => item !== value);
        }
        return { ...prev, [name]: newArr };
      });
    } else {
      setFormData((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleCategorySelect = (category) => {
    setFormData((prev) => ({ ...prev, eventType: category }));
    setShowCategoryDropdown(false);
  };

  // const handleDateInputMouseDown = (e) => {
  //   if (!e.currentTarget?.showPicker) return;
  //   try {
  //     e.preventDefault();
  //     e.currentTarget.showPicker();
  //   } catch (err) {
  //     e.currentTarget.focus();
  //   }
  // };

  const formatDate = (date) => {
    if (!date) return "";
    const d = new Date(date);
    if (isNaN(d.getTime())) return date;
    const day = String(d.getDate()).padStart(2, "0");
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const year = d.getFullYear();
    return `${day}-${month}-${year}`;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.clientName || !formData.eventType || !formData.startDate || !formData.location || !formData.photographyRequirements) {
      setMessage("Please fill in all required fields.");
      setIsSuccess(false);
      setShowMessage(true);
      return;
    }

    const payload = {
      name: formData.clientName,
      category: formData.eventType,
      date: formatDate(formData.startDate),
      city: formData.location,
      requirement: formData.photographyRequirements,
      serviceCategory: "hourly",
      subCategoryType: "Standard",
      subCategory: "Standard"
    };

    try {
      setLoading(true);
      const response = await createHourlyOrEditingQuote(payload);
      setMessage(response?.data?.message || "Quote submitted successfully");
      setIsSuccess(true);
      setShowMessage(true);
    } catch (error) {
      setMessage(
        error?.response?.data?.message ||
        "Something went wrong. Please try again."
      );
      setIsSuccess(false);
      setShowMessage(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {loading && <Loader />}
      <div className="budget-wrapper d-flex justify-content-center align-items-center" style={{ position: 'relative' }}>
        <NavigationButtons />
        <div className="container">
          <h1 className="title text-center mb-5">
            Get your Personalized Hourly Shoot Quote
          </h1>

          <div className="budget-card mx-auto">
            <form onSubmit={handleSubmit}>

              <div className="budget-row">
                <label className="budget-label">
                  Name <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  name="clientName"
                  className="form-control budget-input"
                  placeholder="Enter Name"
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="budget-row">
                <label className="budget-label">
                  Category <span className="text-danger">*</span>
                </label>
                <div className="custom-dropdown-wrapper" ref={categoryDropdownRef} style={{ position: "relative" }}>
                  {/* Hidden input for HTML5 required validation */}
                  <input
                    type="text"
                    value={formData.eventType}
                    required
                    onChange={() => {}}
                    onInvalid={(e) => e.target.setCustomValidity("Please select a category")}
                    onInput={(e) => e.target.setCustomValidity("")}
                    style={{ position: "absolute", opacity: 0, pointerEvents: "none", width: "100%", height: "100%", zIndex: -1 }}
                  />
                  <button
                    type="button"
                    className="form-control budget-input custom-dropdown-btn"
                    onClick={() => setShowCategoryDropdown(!showCategoryDropdown)}
                  >
                    {formData.eventType || "Select Category"}
                    <span className="dropdown-arrow"></span>
                  </button>

                  {showCategoryDropdown && (
                    <div className="custom-dropdown-menu">
                      {services.map((service) => (
                        <div
                          key={service}
                          className="custom-dropdown-item"
                          onClick={() => handleCategorySelect(service)}
                        >
                          {service}
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              </div>

              <div className="budget-row">
                <label className="budget-label">
                  Date <span className="text-danger">*</span>
                </label>
                {/* <input
                  type="date" onClick={(e) => { if(e.target.showPicker) e.target.showPicker(); }}
                  name="startDate"
                  value={formData.startDate}
                  className="form-control budget-input"
                  onMouseDown={handleDateInputMouseDown}
                  onChange={handleChange}
                  required
                /> */}

                <input
                  type="date" onClick={(e) => { if(e.target.showPicker) e.target.showPicker(); }}
                  name="startDate"
                  value={formData.startDate}
                  className="form-control budget-input"
                  onChange={handleChange}
                  min={
                    new Date(Date.now() + 86400000)
                      .toISOString()
                      .split("T")[0]
                  }
                  required
                />
              </div>

              <div className="budget-row">
                <label className="budget-label">
                  City <span className="text-danger">*</span>
                </label>
                <div className="custom-dropdown-wrapper" ref={cityDropdownRef} style={{ width: "100%" }}>
                  {isOtherCity ? (
                    <input
                      type="text"
                      className="form-control budget-input"
                      placeholder="Enter your city name"
                      value={formData.location}
                      onChange={(e) => setFormData({ ...formData, location: e.target.value })}
                      onBlur={() => { if (!formData.location) setIsOtherCity(false); }}
                      required
                    />
                  ) : (
                    <>
                      <input
                        type="text"
                        className="form-control budget-input"
                        placeholder="Search or select city"
                        value={formData.location}
                        onFocus={() => setShowCityDropdown(true)}
                        onChange={(e) => {
                          setFormData({ ...formData, location: e.target.value });
                          setCitySearchTerm(e.target.value);
                          setShowCityDropdown(true);
                        }}
                        required
                      />
                      {showCityDropdown && (
                        <div className="custom-dropdown-menu">
                          {filteredCities.map((city, index) => (
                            <div
                              key={index}
                              className="custom-dropdown-item"
                              onClick={() => {
                                if (city === "Other") {
                                  setIsOtherCity(true);
                                  setFormData({ ...formData, location: "" });
                                } else {
                                  setFormData({ ...formData, location: city });
                                }
                                setCitySearchTerm("");
                                setShowCityDropdown(false);
                              }}
                            >
                              {city}
                            </div>
                          ))}
                        </div>
                      )}
                    </>
                  )}
                </div>
              </div>

              <div className="budget-row">
                <label className="budget-label">
                  Requirements <span className="text-danger">*</span>
                </label>
                <div className="budget-options">
                  {requirementsList.map((req) => (
                    <label key={req} className="budget-option-item">
                      <input
                        type="radio"
                        name="photographyRequirements"
                        value={req}
                        checked={formData.photographyRequirements === req}
                        onChange={(e) => 
                          setFormData((prev) => ({ 
                            ...prev, 
                            photographyRequirements: e.target.value 
                          }))
                        }
                      />
                      {req}
                    </label>
                  ))}
                </div>
              </div>

              <div className="text-center mt-5">
                <button type="submit" className="btn buttons w-50">
                  Submit
                </button>
              </div>

            </form>
          </div>
        </div>
      </div>

      <CommonMessageModal
        show={showMessage}
        onClose={handleModalClose}
        message={message}
      />
    </>
  );
};

export default HourlyStandardQuoteForm;
